import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importa o Bootstrap CSS
import './App.css'; // Seu CSS customizado
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import CheckinPage from './Pages/Checkin/CheckinPage';
import AreaRestritaPage from './Pages/AreaRestrita/AreaRestritaPage';
import BarGerentePage from './Pages/BarGerente/BarGerentePage';
import UsuarioLogadoPage from './Pages/UsuarioLogado/UsuarioLogadoPage';
import BuscarPage from './Pages/Buscar/BuscarPage';
import MostrarDadosEstabelecimento from './Pages/MostrarDadosEstabelecimento/MostrarDadosEstabelecimento';
import FormCadastrarGerente from './Pages/FormCadastrarGerente/FormCadastrarGerente';
import DadosDoEstabelecimento from './Pages/DadosDoEstabelecimento/DadosDoEstabelecimentoPage'

import TabComponent from './components/Tab/TabComponent'; // Mantemos o TabComponent aqui, mas vamos usar só para renderizar as abas

const App = () => {
  return (
    <div className="container mt-4">
      {/* <h1 className="text-center mb-4">Bem-vindo ao Bar Inteligente!</h1> */}
      
      {/* Permitir navegar pelas páginas */}
      <Router>

        <Routes>
          <Route path="/" element={<CheckinPage />} />
          <Route path="/mostrar-dados-estabelecimento" element={<MostrarDadosEstabelecimento />} />
          <Route path="/buscar" element={<BuscarPage />} />
          <Route path="/area-restrita" element={<AreaRestritaPage />} />
          <Route path="/form-cadastrar-gerente" element={<FormCadastrarGerente />} />
          <Route path="/usuario-logado" element={<UsuarioLogadoPage />} />
          <Route path="/bar-gerente" element={<BarGerentePage />} />
          <Route path="/dados-do-estabelecimento" element={<DadosDoEstabelecimento />} />
          
        </Routes>

        {/* Tabs - fora das rotas */}
        <TabComponent />
        
      </Router>
    </div>
  );
};

export default App;
